import { NgModule } from '@angular/core';
import { FiTimePickerPopupComponent } from './time-picker-popup.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

@NgModule({
    imports: [CommonModule, FormsModule, NgxMaterialTimepickerModule],
    declarations: [FiTimePickerPopupComponent],
    exports: [FiTimePickerPopupComponent],
})
export class FiTimePickerPopupModule {}
